import useActionReducer from '@admin/hooks/use_action_reducer'
import * as actions from './actions'
import PropTypes from 'prop-types'
import reducer from './reducer'
import Stars from './stars'
import React from 'react'

export { StarsContext, useStarsContext } from './stars'

const StarsContainer = (props) => {

  const [state, handlers] = useActionReducer({
    display_name: 'stars',
    actions,
    props,
    reducer
  })

  const mergedProps = {
    ...props,
    ...state,
    ...handlers
  }

  return <Stars { ...mergedProps } />

}

StarsContainer.propTypes = {}

export default StarsContainer
